var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgCore = function SvgCore(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFCD38",
    d: "M9.531 3.482 7.754 7.119l-4.02.574c-.71.11-.984.984-.465 1.504l2.872 2.816-.684 3.965c-.11.711.656 1.258 1.285.93l3.582-1.887 3.555 1.887c.629.328 1.394-.219 1.285-.93l-.684-3.965 2.871-2.816c.52-.52.247-1.395-.464-1.504l-3.993-.574-1.804-3.637c-.301-.629-1.23-.656-1.559 0"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCore);
export default ForwardRef;